export enum AutocompleteSearchModelType {
    game = 0,
    instrument = 1,
    style = 2,
    composer = 3,
    tabber = 4,
}